import { io, Socket } from 'socket.io-client';
import { authStorage } from './auth';

// ── Зеркало WS_EVENTS с бэкенда. Имена обязаны совпадать. ──
export const WS_EVENTS = {
  JOIN: 'auction:join',
  LEAVE: 'auction:leave',
  BID_UPDATE: 'auction:bid_update',
  CLOSED: 'auction:closed',
} as const;

// Формат события цены — то, что бэк кладёт в emitBidUpdate.
export interface BidUpdatePayload {
  auction_id: string;
  current_price: number;
  bids_count: number;
  current_leader_id: string | null;
  ends_at: string;
}

// Формат события закрытия.
export interface AuctionClosedPayload {
  auction_id: string;
  status: string;
  winner_id: string | null;
}

let socket: Socket | null = null;

/**
 * Singleton-сокет. Создаётся при первом обращении.
 * path '/socket.io' — дефолт сервера; проксируется через Vite (ws:true),
 * поэтому идёт по тому же ngrok-туннелю, отдельный не нужен.
 */
export function getSocket(): Socket {
  if (socket) return socket;

  socket = io({
    // origin не указываем — берётся текущий (тот же хост, что и фронт).
    // Через Vite-прокси /socket.io уедет на localhost:3000.
    path: '/socket.io',
    // Токен в handshake — на будущее (шаг 10, личные комнаты).
    // Сейчас бэк его читает опционально, для чтения цены не обязателен.
    auth: (cb) => {
      const token = authStorage.getToken();
      cb({ token: token ?? undefined });
    },
    // socket.io сам делает фоллбэк polling↔websocket и реконнект.
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  if (import.meta.env.DEV) {
    socket.on('connect', () => console.log('[socket] connected', socket?.id));
    socket.on('disconnect', (reason) => console.log('[socket] disconnected:', reason));
    socket.on('connect_error', (err) => console.log('[socket] connect_error:', err.message));
  }

  return socket;
}